import React from 'react'
import Loadable from 'react-loadable'
import PageSkeleton from '../components/Skeletons/PageSkeleton'

export const HomepageContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "homepage", webpackPrefetch: true */ './HomepageContainer/HomepageContainer'),
  loading: PageSkeleton,
  modules: ['homepage'],
})

export const ErrorPageContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "errorpage", webpackPrefetch: true */ './ErrorPageContainer/ErrorPageContainer'),
  loading() {
    return <PageSkeleton page='errorpage' />
  },
  modules: ['errorpage'],
})

export const ReviewsContainer = Loadable({
  loader: () => import(/* webpackChunkName: "reviews", webpackPrefetch: true */ './ReviewsContainer/ReviewsContainer'),
  loading() {
    return <PageSkeleton page='reviews' />
  },
  modules: ['reviews'],
})

export const CmsPageContainer = Loadable({
  loader: () => import(/* webpackChunkName: "cmspage", webpackPrefetch: true */ './CmsPageContainer/CmsPageContainer'),
  loading() {
    return <PageSkeleton page='cms' />
  },
  modules: ['cmspage'],
})

export const TaxonomyContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "taxonomy", webpackPrefetch: true */ './TaxonomyContainer/TaxonomyContainer'),
  loading() {
    return <PageSkeleton page='taxonomy' />
  },
  modules: ['taxonomy'],
})

export const RoomCreatorContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "room-creator", webpackPrefetch: true */ './RoomCreatorContainer/RoomCreatorContainer'),
  loading() {
    return <PageSkeleton page='room-creator' />
  },
  modules: ['room-creator'],
})

export const GetTheLookContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "get-the-look", webpackPrefetch: true */ './RoomCreatorContainer/RoomCreatorContainer'),
  loading() {
    return <PageSkeleton page='get-the-look' />
  },
  modules: ['get-the-look'],
})
